import React from "react";
import Context from "../../../Context";
import SuperSelect from "../../Misc/SuperSelect";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Blocker from "../../Misc/Blocker";
import Flex from "../../Misc/Flex";
import SchemeModal from "./SchemeModal";

export default class Scheme extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      lines: [],
      currentItem: {},
      modal: false,
    };
  }

  componentDidMount() {
    this.load();
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
    this.renderButtons();
  }

  load = async () => {
    this.setState({ pending: true });
    let search = [];
    if (this.props.itemId) {
      search.push({
        field: "type",
        compare: "EQL",
        value: this.props.itemId,
      });
    }
    let lines = await this.context.api.qa("/matching/list", {
      search,
      orderby: ["sequence ASC"],
    });
    this.setState({ pending: false, lines });
  };

  onModalClose = () => {
    this.setState({ modal: false });
  };
  onEditStart = (item) => {
    this.setState({ currentItem: item, modal: true });
  };
  onCloneStart = (item) => {
    this.setState({ currentItem: { ...item, id: null }, modal: true });
  };
  onAddStart = () => {
    this.setState({ currentItem: { type: this.props.itemId }, modal: true });
  };
  onAfterSave = () => {
    this.onModalClose();
    this.load();
  };

  onDeleteClick = (item = {}) => {
    this.context
      .ask(
        `Вы действительно хотите удалить действие ${item.activityname} для ${item.positionname}`,
        "Удаление действия из схемы",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item = {}) => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/matching/delete", {
      id: item.id,
    });
    if (result !== false) {
      this.context.toast(`Действие удалено из схемы`, "success");
      this.load();
    } else {
      this.context.toast(`Не удалось удалить действие`, "error");
    }

    this.setState({ pending: false });
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        {this.props.itemId && (
          <div onClick={this.onAddStart} className={`btn btn-light p-2  mr-2`}>
            <span className="flaticon2-add-1 px-2 align-middle"></span>
          </div>
        )}
      </>
    );
  };

  render() {
    const { pending, lines, currentItem, modal } = this.state;
    return (
      <>
        <CrumbsProvider title="Параметры" link="/reference/" />
        <CrumbsProvider title="Схемы согласовния" link="/scheme/" />

        <SchemeModal
          item={currentItem}
          show={modal}
          onAfterSave={this.onAfterSave}
          onModalClose={this.onModalClose}
        />

        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <div className="card-body px-5 py-5">
                  <Blocker on={pending}>
                    <div className="mb-4 pb-4 border-bottom">
                      <div className="row">
                        <div className="col-12">
                          <SuperSelect
                            grey
                            anyState
                            defaultValue={this.props.itemId}
                            onChange={(value) =>
                              this.context.redirect(`/scheme/${value}`)
                            }
                            essence="type"
                            forcePath="/type"
                            placeholder="Выберите тип..."
                            nameField="name"
                            labelFn={(item) => `${item.name} / ${item.code}`}
                            idField="id"
                          />
                        </div>
                      </div>
                    </div>
                    {lines.length > 0 && (
                      <>
                        <div className="row text-dark-50 pb-3 mb-3 border-bottom pt-4">
                          <div className="col">Тип документа</div>
                          <div className="col">Состояние документа</div>
                          <div className="col">Структура организации</div>
                          <div className="col">Сотрудник</div>
                          <div className="col">Действие</div>
                        </div>
                        {lines.map((line, idx) => {
                          let item = line || {};
                          return (
                            <div className="row pb-3 mb-3" key={idx}>
                              <div className="col   text-muted">
                                {item.typename}
                                <div className="small text-dark-50 font-italic">
                                  {item.typecode}
                                </div>
                              </div>
                              <div className="col">
                                {item.statelabel}
                                <div className="small text-muted font-italic">
                                  {item.statecode}
                                </div>
                              </div>
                              <div className="col">
                                {item.structurename}
                                <div className="small text-muted font-italic">
                                  {item.structuredescription}
                                </div>
                              </div>
                              <div className="col">
                                {item.positionname && (
                                  <div>
                                    {item.membername ? (
                                      <div className="small text-dark-75">
                                        {item.positionname}
                                      </div>
                                    ) : (
                                      <div>{item.positionname}</div>
                                    )}
                                  </div>
                                )}

                                {item.membername}
                                <div className="small text-muted font-italic">
                                  {item.positiondescription}
                                </div>
                              </div>

                              <div className="col">
                                <Flex between>
                                  <div>
                                    {item.activityname}
                                    <div className="small text-muted font-italic">
                                      {item.activitydescription}
                                    </div>
                                  </div>
                                  <div className="nowrap">
                                    <span
                                      title="Изменить"
                                      onClick={() => this.onEditStart(item)}
                                      className="flaticon2-edit px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                                    ></span>
                                    <span
                                      title="Копировать"
                                      onClick={() => this.onCloneStart(item)}
                                      className="fa fa-clone px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                                    ></span>
                                    <span
                                      title="Удалить"
                                      onClick={() => this.onDeleteClick(item)}
                                      className="flaticon2-rubbish-bin px-2 align-middle cursor-pointer text-muted text-hover-danger"
                                    ></span>
                                  </div>
                                </Flex>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </Blocker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
